<template>
    <html>
    <body style="position: relative;background: #fff">
        <!--banner-->
        <div class="nbanner" style="height: auto"> <img src="@/assets/styles/images/zh01.png" alt=""> </div>
        <!--主体开始-->
        <section class="section zhihui">
            <div class="title1"> 产品列表 </div>
            <div class="neit">
                <ul>
                    <li>
                        <a href="/zhihui/iot">
                            <div class="zi">
                                <h2>01</h2>
                                <h3>智慧农业物联网</h3>
                                <p>农业物联网就是在大棚等系统中，安装大量的传感器构成监测网络，通过各种传感器采集信息，经过数据分析处理，依托自动化，智能化，远程控制生产的设备，来远程控制农作物生长条件，使之可以在最适宜的条件下生长，从而不受季节环境等因素的限制。</p>
                            </div>
                            <div class="tu">
                                <div><img src="@/assets/styles/images/zh3.png" alt=""></div>
                                <img src="@/assets/styles/images/zh4.png" alt="">
                            </div>

                        </a>
                    </li>
                    <li>
                        <a href="/zhihui/ts">
                            <div class="tu">
                                <div><img src="@/assets/styles/images/zh2.png" alt=""></div>
                                <img src="@/assets/styles/images/zh4.png" alt="">
                            </div>
                            <div class="zi">
                                <h2>02</h2>
                                <h3>农产品溯源系统</h3>
                                <p>农产品质量监管及溯源系统2.0版是在现行农业标准化生产的基础上，建立生产者、批发商、消费者和监管者“四位一体”的共享平台，包括农产品质量安全溯源系统（种植业、养殖业）、农产品质量安全监管系统等，达到“生产过程可监督、农业投入品可管控、质量安全可监管、产品责任可追溯、优质产品可查询”的目标、从而全方位发挥监督、鼓励、鞭策和推动作用，建立质量安全监管机制、创建现代农业管理新模式。</p>
                            </div>
                        </a>
                    </li>
                </ul>
            </div>
        </section>
    </body>
</html>
</template>

<script>
    export default {
        name: '',
        components: {},
        data: () => {
            return {

            };
        },
        created() {

            let wintitle = `${window.document.title}`;
            let title = wintitle.split('-')
            window.document.title = '智慧农业 - ' + title[1];

        },

        methods: {

        },
    }
</script>
